//#region Styles
import { ContainerParts } from "components/styles";
//#endregion
//#region Components
import Part1 from "./components/Part1/Part1";
import Part2 from "./components/Part2/Part2";
import Part2_1 from "./components/Part2_1/Part2_1";
import Part3 from "./components/Part3/Part3";
import { useEffect, useState } from "react";
import { EVENTS_CONSTANTS } from "config/constants";
//#endregion

const Step1 = ({
	isCreate,
	form,
	changeForm,
	changePayGradeField,
	errors,
	allDays,
	eventResumeData,
}) => {
	//#region Functions
	const changeFieldPart1 = (field, value, errorValue) => {
		changeForm("part1", field, value, errorValue);
	};
	const changeFieldPart2 = (field, value, errorValue) => {
		changeForm("part2", field, value, errorValue);
	};
	const changeFieldPart3 = (field, value, errorValue) => {
		changeForm("part3", field, value, errorValue);
	};
	//#endregion
	const [isCulturalOrSport, setIsCulturalOrSport] = useState(false);
	const [isConferenceOrActivity, setIsConferenceOrActivity] = useState(false);
	const [isProfessionalTools, setIsProfessionalTools] = useState(false);
	const [selectedCourseName, setSelectedCourseName] = useState('');
	const { eventSubtypeId, eventTypeId } = form.part2;
	
	useEffect(() => {
		const isCulturalOrSportSubtype =
			eventSubtypeId === EVENTS_CONSTANTS.EVENT_SUBTYPES.CULTURAL ||
			eventSubtypeId === EVENTS_CONSTANTS.EVENT_SUBTYPES.SPORT
			

		const isProfessionalToolsSubtype = eventSubtypeId === EVENTS_CONSTANTS.EVENT_SUBTYPES.PROFESSIONAL_TOOLS;

		const isConferenceOrActivityType =
			eventTypeId === EVENTS_CONSTANTS.EVENT_TYPES.CONFERENCES ||
			eventTypeId === EVENTS_CONSTANTS.EVENT_TYPES.ACTIVITIES;

		setIsCulturalOrSport(isCulturalOrSportSubtype);
		setIsConferenceOrActivity(isConferenceOrActivityType);
		setIsProfessionalTools(isProfessionalToolsSubtype);

	}, [eventSubtypeId, eventTypeId]);

	return (
		<ContainerParts>
			<Part1
				form={form.part1}
				changeField={changeFieldPart1}
				errors={errors.part1}
				isProfessionalTools={isProfessionalTools}
				selectedCourseName={selectedCourseName}
			/>
			<Part2
				form={form.part2}
				// changeFieldPart1={changeFieldPart1}
				changeField={changeFieldPart2}
				changeFieldPart3={changeFieldPart3}
				changePayGradeField={changePayGradeField}
				errors={errors.part2}
				eventResumeData={eventResumeData}
				setSelectedCourseName={setSelectedCourseName}
				//setIsCulturalOrSport={(value) => setIsCulturalOrSport(value)}
			/>
			{form.part2.eventTypeId > 0 && (
				<Part2_1
					form={form.part2}
					changeField={changeFieldPart2}
					errors={errors.part2}
				/>
			)}
			<Part3
				form={form.part3}
				changeField={changeFieldPart3}
				errors={errors.part3}
				eventTypeId={form.part2.eventTypeId}
				isCreate={isCreate}
				allDays={allDays}
				eventResumeData={eventResumeData}
				isCulturalOrSport={isCulturalOrSport}
				isConferenceOrActivity={isConferenceOrActivity}
				isProfessionalTools={isProfessionalTools}
			/>
		</ContainerParts>
	);
};
export default Step1;
